import React from 'react';
import Header from '../componentes/Header';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';
import { Link, useNavigate} from 'react-router';
import productosSuperOfertas from '../data/todosLosProductos/productosSuperOfertas'
import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import styled from 'styled-components';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PaginaSuperOfertas = () => {
    const navigate = useNavigate();
    return ( 
        <>
        <Helmet>
            <title>Super Ofertas | Hi Blinds</title>
            <meta name="description" content="Aprovecha descuentos en persianas, cortinas y más. Calidad Hi Blinds a precios únicos." />
            <meta property="og:title" content="Super Ofertas | Hi Blinds" />
            <meta property="og:description" content="Promociones especiales por tiempo limitado. ¡No te las pierdas!" />
            <meta property="og:url" content="https://hiblindsmx.com/super-ofertas" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>
                    <motion.h1>
                        Super Ofertas
                    </motion.h1>
                    <BtnVolverAnim Ref='/' />
                    
                <ContainerProductos>
                    {productosSuperOfertas.map((producto, index) =>  {

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer key={producto.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                             onClick={() => {
                              navigate(`/super-ofertas/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}
                              >
                                <img 
                                loading='lazy' 
                                src={producto.images[0]}
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Ancho:
                                    <br/> {producto.ancho}
                                </p>
                                <Link to={`/super-ofertas/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                    <BtnVolverAnim Ref='/' />
                    <WhatsAppShareButton message="¡Revisa nuestros Tejidos Exclusivos!" />
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            
        </>
     );
}

export default PaginaSuperOfertas;